export default "__VITE_ASSET__BjZPzM0f__"